// return '/rest/v2/supplier/' + this.supplier + '/document?type=' + this.typeid;
//
// nda type 1
// contract type 2
//

import Reflux from 'reflux';
import { actions } from 'actions';


var SupplierDocumentStore = Reflux.createStore({

  init: function() {
    this.listenTo(actions.getDocuments, this.getDocuments);
    this.listenTo(actions.deleteDocument, this.deleteDocument);
  },
  getDocuments: function(supplierId) {
    fetch('/rest/v2/supplier/'+supplierId + '/document').then((response) => {
      return response.json();
    }).then(data => {
      this.trigger({ documents: data });
    });
  },
  deleteDocument: function(supplierId, uid, type) {
    fetch('/rest/v2/supplier/'+supplierId + '/document' + '/' + uid, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      this.getDocuments(supplierId);
    });
  }
})

export { SupplierDocumentStore };
